export default __webpack_public_path__ + "static/media/pxg.cfee4e5b.gif";